import { render } from "./DataPekerjaan.vue?vue&type=template&id=1a853a3a"
import script from "./DataPekerjaan.vue?vue&type=script&lang=js"
export * from "./DataPekerjaan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__